export const companyAddressLines = ["Commarec s.r.o.", "Varšavská 715/36", "120 00 Praha 2", "Česká republika"];
